import { React, Component, createRef } from "react";
import "./Compose.css";
import { Add, Assignment, AttachFile, AutoAwesome, AutoFixHigh, AutoFixOff, Ballot, Close, InsertEmoticon, OnlinePrediction, RecordVoiceOver, Send, ShoppingCart } from "@mui/icons-material";
import ToolTip from "@mui/material/Tooltip";
import Global from "../../customlib/Global";
import { Avatar, Box, Divider, Grid, IconButton, LinearProgress, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Popover, Typography } from "@mui/material";

// Kumpulan emoji yang sering dipakai untuk emoji picker (ala WhatsApp)
const EMOJI_LIST = [
  "😀", "😁", "😂", "🤣", "😊", "😍", "😘", "😎",
  "🤩", "😉", "🙂", "🙃", "😇", "🥰", "😋", "😜",
  "🤔", "🤗", "😅", "😆", "🥳", "😴", "😢", "😭",
  "😡", "😱", "😬", "🙄", "😏", "😌", "👍", "👎",
  "🙏", "👏", "🙌", "💪", "👌", "✌️", "🤝", "👋",
  "❤️", "🧡", "💛", "💚", "💙", "💜", "💯", "🔥",
  "✨", "🎉", "🎁", "🌹", "💐", "🌸", "☀️", "⭐",
  "✅", "❌", "⚠️", "💬", "📌", "📞", "🛒", "💰",
];

class Compose extends Component {
  state = {
    isMenuOpen: false,
    anchorEl: null,
    isEmojiOpen: false,
    emojiAnchorEl: null,
    // Draft pesan disimpan lokal agar mengetik tidak memicu re-render parent (MessageList)
    draft: this.props.messageValue || "",
  };

  textareaRef = createRef();

  componentDidUpdate(prevProps) {
    // Sinkron dari parent hanya bila parent yang mengubah teks (pilih suggestion,
    // isi template HSM, atau dikosongkan setelah terkirim) — bukan saat user mengetik.
    if (
      prevProps.messageValue !== this.props.messageValue &&
      this.props.messageValue !== this.state.draft
    ) {
      this.setState({ draft: this.props.messageValue || "" });
    }
  }

  // Update draft lokal saja (tidak menyentuh parent) -> mengetik jadi ringan
  handleLocalChange = (event) => {
    this.setState({ draft: event.target.value });
  };

  // Saat kirim: dorong draft ke parent dulu, lalu panggil onSendMessage setelah
  // state parent ter-commit (setTimeout 0) supaya parent membaca teks terbaru.
  flushAndSend = (sendArg) => {
    this.props.onChange({ target: { value: this.state.draft } });
    setTimeout(() => this.props.onSendMessage(sendArg), 0);
  };

  handleOpenMenu = (event) => {
    this.setState({ anchorEl: event.target, isMenuOpen: true });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null, isMenuOpen: false });
  };

  handleOpenEmoji = (event) => {
    this.setState({ emojiAnchorEl: event.currentTarget, isEmojiOpen: true });
  };

  handleCloseEmoji = () => {
    this.setState({ emojiAnchorEl: null, isEmojiOpen: false });
  };

  handleEmojiSelect = (emoji) => {
    // Sisipkan emoji tepat di posisi kursor (popup tetap terbuka) — ke draft lokal
    const current = this.state.draft || "";
    const textarea = this.textareaRef.current;
    const start = textarea ? textarea.selectionStart : current.length;
    const end = textarea ? textarea.selectionEnd : current.length;

    const newValue = current.slice(0, start) + emoji + current.slice(end);
    this.setState({ draft: newValue });

    // Kembalikan fokus & posisi kursor setelah emoji tersisip
    const cursorPos = start + emoji.length;
    requestAnimationFrame(() => {
      const el = this.textareaRef.current;
      if (el) {
        el.focus();
        el.setSelectionRange(cursorPos, cursorPos);
      }
    });
  };

  onKeyDownHandler = (e) => {
    // Ctrl+Enter atau Shift+Enter mengirim pesan; Enter biasa membuat baris baru
    if (e.keyCode === 13 && (e.ctrlKey || e.shiftKey)) {
      this.flushAndSend();
    }
  };

  getStyleBtnCs = () => {
    const conversation = this.props.currentConversation;
    return conversation.csHelpState !== undefined && conversation.csHelpState !== "OFF"
      ? "btn btn-warning"
      : "btn btn-secondary";
  };

  getStyleBtnLabel = () => {
    const conversation = this.props.currentConversation;
    return conversation.contactLabel !== undefined && conversation.contactLabel !== ""
      ? "btn btn-warning"
      : "btn btn-secondary";
  };

  handleSetLabelClick = () => {
    const { contactLabel } = this.props.currentConversation;

    if (Global.isCustomerService() || Global.isCustomerServiceSpv()) {
      if (contactLabel !== undefined && contactLabel === Global.labelPaid()) {
        this.props.onSetContactLabelClick();
      }
    } else if (
      contactLabel === undefined ||
      contactLabel === Global.labelBelumDiresponCustomer() ||
      contactLabel === Global.labelLeadsPooling() ||
      contactLabel === "" ||
      contactLabel === Global.labelUnpaid() ||
      contactLabel === Global.labelDp() ||
      contactLabel === Global.labelCancel() ||
      contactLabel === Global.labelPending()
    ) {
      this.props.onSetContactLabelClick();
    } else if (Global.get().admin === true || Global.isAdminTeleUser() || Global.isTeleCutomer()) {
      this.props.onSetContactLabelClick();
    }

    this.handleCloseMenu();
  };

  handleCsHelpClick = () => {
    const { csHelpState } = this.props.currentConversation;

    if (csHelpState === undefined || csHelpState === "OPEN" || csHelpState === "OFF") {
      this.props.onCsHelpButtonClick();
    } else if (Global.get().admin === true || Global.isCustomerServiceSpv()) {
      this.props.onCsHelpButtonClick();
    }
  };

  ComponentSetLabel = () => {
    const { contactLabel } = this.props.currentConversation;
    const hasLabel = contactLabel !== undefined && contactLabel !== "";

    return (
      <ToolTip title="Label Customer">
        <button
          onClick={this.handleSetLabelClick}
          className={`${this.getStyleBtnLabel()} btn-label`}
          type="button"
          id="button-addon2"
        >
          {!hasLabel && (
            <div><div className="badge badge-pill badge-dark">Set Label</div></div>
          )}
          {hasLabel && (
            <div><div className={Global.getLabelClasses(contactLabel)}>{contactLabel}</div></div>
          )}
        </button>
      </ToolTip>
    );
  };

  // Daftar aksi yang dikelompokkan di balik tombol "+" (hemat tempat, ala WhatsApp Web)
  getPlusMenuActions = () => [
    {
      key: "attachment",
      label: "Attachment",
      icon: <AttachFile fontSize="small" sx={{ color: "#ff5c75" }} />,
      onClick: () => this.props.onOpenDropZone(),
    },
    {
      key: "hsm",
      label: "Pesan Template",
      icon: <Assignment fontSize="small" sx={{ color: "#475467" }} />,
      onClick: () => this.props.onTemplateButtonClick(),
    },
    {
      key: "order",
      label: "Kirim Form Order",
      icon: <ShoppingCart fontSize="small" sx={{ color: "#22c55e" }} />,
      onClick: () => this.props.onSendFormOrderClick(),
    },
    {
      key: "catalogue",
      label: "Kirim Katalog",
      icon: <Ballot fontSize="small" sx={{ color: "#22c55e" }} />,
      onClick: () => this.props.onSendCatalogueClick(),
    },
  ];

  handlePlusMenuItemClick = (action) => {
    action.onClick();
    this.handleCloseMenu();
  };

  ComponentCsHelp = () => {
    const { csHelpState } = this.props.currentConversation;
    return (
      <ToolTip title="Status bantuan CS">
        <button
          onClick={this.handleCsHelpClick}
          className={this.getStyleBtnCs()}
          type="button"
          id="button-addon2"
        >
          <RecordVoiceOver key="csHelp" className="text-center" style={{ color: "#FFFFFF" }} />
          {(csHelpState === undefined || csHelpState === "OFF") && <div><small>Oper ke CS</small></div>}
          {csHelpState === "OPEN" && <div><small>Menunggu CS</small></div>}
          {csHelpState === "SOLVING" && <div><small>Sedang Diproses</small></div>}
          {csHelpState === "SOLVED" && <div><small>CS Selesai</small></div>}
        </button>
      </ToolTip>
    );
  };

  render() {
    const isDesktop = this.props.isMobile && this.props.isMobile() !== true;
    const isMobileView = this.props.isMobile && this.props.isMobile() === true;
    const messageLength =
      this.state.draft && this.state.draft.length > 0
        ? this.state.draft.trim().length
        : null;

    return (
      <Paper elevation={5} sx={{backgroundColor: "rgb(234, 238, 242)", p: "0px"}}>
        <div className="compose">
          <div className="input-group" style={{ margin: 0 }}>
            <div className="input-group-append">
              {isDesktop && <this.ComponentSetLabel />}

              {isDesktop &&
                this.props.currentConversation.contactLabel !== undefined &&
                this.props.currentConversation.contactLabel === "DP" && <this.ComponentCsHelp />}

              {/* Satu tombol "+" yang membuka menu berisi Attachment, Pesan Template, Kirim Form Order, Kirim Katalog */}
              <ToolTip title="Lampiran & lainnya">
                <button className="btn btn-primary btn-plus" type="button" onClick={this.handleOpenMenu}>
                  <Add />
                </button>
              </ToolTip>

              {/* Tombol emoji (ala WhatsApp) di sebelah kanan tombol + */}
              <ToolTip title="Emoji">
                <button className="btn btn-primary btn-emoji" type="button" onClick={this.handleOpenEmoji}>
                  <InsertEmoticon color="#ffffff"/>
                </button>
              </ToolTip>
            </div>

            <textarea
              ref={this.textareaRef}
              onKeyDown={this.onKeyDownHandler}
              value={this.state.draft}
              onChange={this.handleLocalChange}
              type="text"
              className="form-control"
              placeholder="Ketikkan pesan anda di sini"
              aria-label="Ketikkan pesan anda di sini"
              aria-describedby="button-addon2"
            />

            <div className="input-group-append">
              <ToolTip title="Suggestions">
                <button onClick={this.props.toggleShowSuggestion} className="btn btn-warning" type="button" id="button-addon2">
                  <AutoFixHigh key="composesend" className="text-center" style={{ color: "#FFFFFF" }} />
                </button>
              </ToolTip>
              <ToolTip title={"Kirim Pesan"}>
                <button onClick={() => this.flushAndSend(null)} className="btn btn-primary" type="button" id="button-addon2">
                  <Send key="composesend" className="text-center" style={{ color: "#FFFFFF" }} />
                  {
                    messageLength !== null && (
                      <Box>
                        <small style={{ fontSize: "10px" }}>{messageLength}</small>
                      </Box>
                    )
                  }
                </button>
              </ToolTip>
            </div>
          </div>
        </div>

        <Menu
          anchorEl={this.state.anchorEl}
          open={this.state.isMenuOpen}
          onClose={this.handleCloseMenu}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "bottom", horizontal: "left" }}
          slotProps={{ paper: { sx: { borderRadius: "12px", minWidth: 200, mt: "-6px" } } }}
        >
          {isMobileView && (
            <MenuItem sx={{ padding: 0, margin: 0 }}><this.ComponentSetLabel /></MenuItem>
          )}
          {this.getPlusMenuActions().map((action) => (
            <MenuItem key={action.key} onClick={() => this.handlePlusMenuItemClick(action)}>
              <ListItemIcon>{action.icon}</ListItemIcon>
              <ListItemText>{action.label}</ListItemText>
            </MenuItem>
          ))}
        </Menu>

        <Popover
          open={this.state.isEmojiOpen}
          anchorEl={this.state.emojiAnchorEl}
          onClose={this.handleCloseEmoji}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "bottom", horizontal: "left" }}
          slotProps={{ paper: { sx: { borderRadius: "12px", mt: "-8px", p: 1 } } }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(8, 1fr)",
              gap: "2px",
              width: 300,
              maxWidth: "100%",
              boxSizing: "border-box",
              maxHeight: 220,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {EMOJI_LIST.map((emoji, index) => (
              <IconButton
                key={index}
                size="small"
                onClick={() => this.handleEmojiSelect(emoji)}
                sx={{
                  width: "100%",
                  minWidth: 0,
                  p: "4px",
                  fontSize: 20,
                  borderRadius: "8px",
                  color: "#000",
                  opacity: 1,
                  lineHeight: 1,
                }}
              >
                {emoji}
              </IconButton>
            ))}
          </Box>
        </Popover>

        {this.props.showSuggestions && (
          <Paper
            elevation={2}
            sx={{ zIndex: 100000, position: "absolute", borderRadius: "30px", bottom: 70, right: "1vw", padding: "8px", backgroundColor: "#deecfd99", minWidth: "30vw", maxWidth: "30vw" }}
          >
            <Box
              sx={{ fontWeight: "normal", fontSize: "13px", backgroundColor: "#8da2f6f7", padding: "15px", borderRadius: "30px", maxHeight: "80vh", overflowY: "auto" }}
              className="text-xs"
            >
              <Grid container spacing={1}>
                <Grid item xs={11} textAlign={"left"}>
                  <Typography variant="h6">Suggestions <AutoAwesome /></Typography>
                </Grid>
                <Grid item xs={1} textAlign={"center"}>
                  <IconButton color="error" size="small" onClick={this.props.toggleShowSuggestion}><Close /></IconButton>
                </Grid>
              </Grid>

              <Divider sx={{ mt: "10px" }} />

              {this.props.isLoadingSuggestion && (
                <Box textAlign={"center"} sx={{ color: "#FFFFFF" }}>
                  <LinearProgress sx={{ mb: "10px" }} />
                  <OnlinePrediction /> <strong>Thinking, please wait...</strong><br />
                </Box>
              )}

              {!this.props.isAiSuggestionActive && (
                <Box textAlign={"center"} sx={{ mt: "10px" }}>
                  <AutoFixOff color="error" />
                  <Box sx={{ mt: "10px", color: "#a40303" }}>
                    Hanya aktif apabila pesan terakhir berasal dari customer
                  </Box>
                </Box>
              )}

              <List sx={{ width: "100%" }}>
                {this.props.suggestionData?.suggestions?.map((item, index) => (
                  <ListItemButton
                    key={item.uuid}
                    alignItems="flex-start"
                    sx={{ borderRadius: "10px" }}
                    dense
                    onClick={() => this.props.onSelectSuggestion(item)}
                    color={item.isSelected ? "primary" : ""}
                  >
                    <ListItemAvatar>
                      <Avatar alt={item.isSelected ? "✓" : (index + 1) + ""} src="/1.jpg" />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Box>
                          <Typography component="span" variant="body2" sx={{ color: "text.primary" }}>
                            {item.isSelected
                              ? <Box sx={{ color: "#02047f", fontWeight: "bold" }}>{item.text}</Box>
                              : <Box sx={{ color: "#323233" }}>{item.text}</Box>}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItemButton>
                ))}
              </List>
            </Box>
          </Paper>
        )}
      </Paper>
    );
  }
}

export default Compose;
